module.exports = __webpack_public_path__ + "img/wifi_odd.ab842734.svg";